import Vue from 'vue'
import Vuex from 'vuex'
import { isObjects } from 'js/utils.js'

Vue.use(Vuex)


const state = {
    direction:null,
    startNode: {},
    endNode: {},
    hasNoticeMsg:false
};

const getters = {}

//不可进行异步操作
const mutations = {
    setNode(state, value) {
        if (!value) {
            return false;
        }
        let type = value.type
        delete value.type
        let str = JSON.stringify(value);
        let name = "startNode";
        if (type == 2) {
            name = "endNode";
        }
        state[name] = value
        sessionStorage.setItem(name, str);
    },
    setDirection(state, value) {

        if (!value) {
            return false;
        }

        let str = JSON.stringify(value);
        state["direction"] = value
        sessionStorage.setItem("direction", str);
    },
    setNoticeMsg(state, value) {

        if (!value) {
            return false;
        }

        let str = JSON.stringify(value);
        state["hasNoticeMsg"] = value
        sessionStorage.setItem("hasNoticeMsg", str);
    }
}

//触发mutations里面对应的方法可进行异步操作
const actions = {
    setNode(context, value) {
        context.commit('setNode', value);
    },
    setDirection(context, value) {
        context.commit('setDirection', value);
    },
    setNoticeMsg(state, value) {
        context.commit('setNoticeMsg', value);      
    }
};

// 页面刷新时，会从sessionStorage中重新读取并赋值
for (let key in state) {
    console.log(sessionStorage.getItem(key))
    if (sessionStorage.getItem(key)) {
        let o = sessionStorage.getItem(key);
        console.log(key,isObjects(o))
        state[key] = isObjects(o) ? JSON.parse(o) : o
    }
}



export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {}
})